module.exports = __webpack_public_path__ + "img/background-line.9174c130.svg";